import React, { Component } from 'react';

class MatrixZoneTable extends Component {
    render() {
        const { zones, zonesShowing, sort, sortAsc, toggleSelectZone, toggleShowZone, updateSort, toggleShowAllZones } = this.props;

        let arrow;
        if (sortAsc) {
            arrow = <span className="glyphicon glyphicon-triangle-bottom" title="Active" />;
        } else {
            arrow = <span className="glyphicon glyphicon-triangle-top" title="Inactive" />;
        }

        const zoneListTableContents = zones.map(zone => {
            return (
                <div
                    key={zone._id}
                    className={
                        'row matrix-zone-list-row' +
                        (zone.isSelected ? ' on' : ' off') +
                        (zone.isShowing ? '' : ' not-clickable')
                    }
                    onClick={() => toggleSelectZone(zone._id)}
                >
                    <div className="text-center col-sm-2 center-vertical">
                        <input
                            type="checkbox"
                            className="checkbox-center"
                            onChange={() => toggleShowZone(zone._id)}
                            checked={zone.isShowing}
                        />
                    </div>
                    <div className="text-center col-sm-5 center-vertical">{zone.name}</div>
                </div>
            );
        });

        return (
            <div id="available-zone-list-table">
                <h4>Available Zones</h4>
                <div className="zone-list-head flex-center">
                    <div className="text-center table-header col-sm-2">Show?</div>
                    <div
                        className="text-center table-header table-header-clickable col-sm-5"
                        onClick={() => updateSort('name')}
                    >
                        Name {sort === 'name' ? arrow : ''}
                    </div>
                </div>
                <div className="row matrix-device-list-row off not-clickable select-all-or-none">
                    <div className="text-center col-sm-2 center-vertical">
                        <input
                            type="checkbox"
                            className="checkbox-center"
                            onChange={toggleShowAllZones}
                            checked={zones.every(({ isShowing }) => isShowing)}
                        />
                    </div>
                    <div className="text-center col-sm-10 center-vertical bold">
                        Showing {zonesShowing.length} / {zones.length}
                    </div>
                </div>
                <div className="main-table">{zoneListTableContents}</div>
            </div>
        );
    }
}

export default MatrixZoneTable;
